export const FETCH_CUSTOMER = 'CUSTOMER/FETCH_CUSTOMER';
export const FETCH_CUSTOMER_ERROR = 'CUSTOMER/FETCH_CUSTOMER_ERROR';
export const FETCH_CUSTOMER_SUCCESS = 'CUSTOMER/FETCH_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_DATA = 'CUSTOMER/UPDATE_CUSTOMER_DATA';
export const SET_LOGIN_FORM_DATA = 'CUSTOMER/SET_LOGIN_FORM_DATA';
export const RESET_LOGIN_FORM_PASSWORD = 'CUSTOMER/RESET_LOGIN_FORM_PASSWORD';
export const UPDATE_CUSTOMER_SUBSCRIPTION_PREFERENCES = 'UPDATE_CUSTOMER_SUBSCRIPTION_PREFERENCES';
export const UPDATE_CUSTOMER_SUBSCRIPTION_PREFERENCES_ERROR = 'UPDATE_CUSTOMER_SUBSCRIPTION_PREFERENCES_ERROR';
export const UPDATE_CUSTOMER_AUTH_STATUS = 'CUSTOMER/UPDATE_CUSTOMER_AUTH_STATUS';
